<template>
  <base-section
    id="overview"
    space="64"
  >
    <v-container>
      <v-row justify="center">
        <v-col
          cols="12"
          md="10"
        >
          <base-section-heading
            :title="overview.title || $t('overview.title')"
            :subtitle="overview.subtitle || $t('overview.subtitle')"
            :is-uppercase="false"
            :space="4"
          />
          <base-body space="6">
            {{ overview.content || $t('overview.content') }}
          </base-body>
          <base-body space="6">
            {{ overview.content2 || $t('overview.content2') }}
          </base-body>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionOverview',

    data: () => ({
      overview: {
        title: '',
        subtitle: '',
        content: '',
        content2: '',
      },
    }),

    watch: {
      '$i18n.locale'() {
        this.loadOverview()
      },
    },

    async mounted() {
      await this.loadOverview()
    },

    methods: {
      async loadOverview() {
        try {
          const blocks = await this.$axios({
            method: 'get',
            url: '/public/homepage',
            params: { lang: this.$i18n.locale },
          })
          const overview = (blocks || []).find(b => b.blockKey === 'overview')
          if (overview) {
            this.overview = {
              title: overview.title,
              subtitle: this.overview.subtitle,
              content: overview.content,
              content2: this.overview.content2,
            }
          }
        } catch (error) {
          // fallback to i18n
        }
      },
    },
  }
</script>
